import { render, staticRenderFns } from "./TemplateWizard.vue?vue&type=template&id=55eeec7c&scoped=true"
import script from "./TemplateWizard.vue?vue&type=script&lang=js"
export * from "./TemplateWizard.vue?vue&type=script&lang=js"
import style0 from "./TemplateWizard.vue?vue&type=style&index=0&id=55eeec7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eeec7c",
  null
  
)

export default component.exports